var $fc9aec6a28d8da4a$exports = {};
const $fc9aec6a28d8da4a$var$translations = {
    en: {
        // Navigation
        home: "Home",
        recitation: "Recitation",
        quran: "Quran",
        hadith: "Hadith",
        contact: "Contact Us",
        menu: "Menu",
        // Dropdowns
        language: "Language",
        // Language options
        arabic: "Arabic",
        english: "English",
        // Hero
        heroTitle: "Your companion in recitation",
        heroSubTitle: "Listen to beautiful Quran recitations from your favorite readers with access to over 250 trusted reciters and multiple recitations from across the Islamic world.",
        ctaButton: "Start Listening",
        // Recitaion
        selectReciter: "Select Reciter:",
        selectNarration: "Select Rewaya:",
        selectSurah: "Select Surah:",
        // Conatct
        contactHeading: "Contribute",
        // contribute links
        contactDesc: "Help improve this project by contributing code or reporting issues",
        fundTitle: "Fund project",
        fundDesc: "Not available for now!",
        contributeTitle: "View Repository",
        contributeDesc: "Star our project",
        issueTitle: "Report Issues",
        issueDesc: "Help us find and fix bugs",
        pullReqTitle: "Submit Pull Request",
        pullReqDesc: "Contribute by code",
        // tool tip
        toolTipTitle: "Form Submission",
        // conatct form
        formTitle: "Contact Us",
        formNameHolder: "Full name *",
        formEmailHolder: "Email Address *",
        formMsgHolder: "Your message *",
        formSubmit: "Send Message",
        // Pop Up
        successTitle: "Message Sent!",
        successMsg: "Thank you for your message. We'll get back to you soon.",
        popClose: "Close",
        errorTitle: "Error",
        errorMsg: "Thank you for your message. We'll get back to you soon.",
        // Fotter
        footerNav: "Navigation",
        footerLinks: "Links",
        footerAPI: "API Credits",
        footerWebSites: "Similar websites",
        footerNewsletter: "Stay Updated",
        footerEmailPlaceholder: "Your Email",
        footerSubscribe: "Subscribe",
        footerPrivacy: "Privacy Policy",
        footerTerms: "Terms of Service",
        footerLicense: "License"
    },
    ar: {
        // Navigation
        home: "\u0627\u0644\u0631\u0626\u064A\u0633\u064A\u0629",
        recitation: "\u0627\u0644\u062A\u0644\u0627\u0648\u0629",
        quran: "\u0627\u0644\u0642\u0631\u0622\u0646",
        hadith: "\u062D\u062F\u064A\u062B",
        contact: "\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627",
        // Dropdowns
        language: "\u0627\u0644\u0644\u063A\u0629",
        // Language options
        arabic: "\u0627\u0644\u0639\u0631\u0628\u064A\u0629",
        english: "\u0627\u0644\u0625\u0646\u062C\u0644\u064A\u0632\u064A\u0629",
        //  Hero
        heroTitle: "\u0627\u0644\u0645\u0624\u0646\u0633 \u0631\u0641\u064A\u0642\u0643 \u0641\u064A \u0627\u0644\u062A\u0644\u0627\u0648\u0629",
        heroSubTitle: "\u0627\u0633\u062A\u0645\u0639 \u0625\u0644\u0649 \u062A\u0644\u0627\u0648\u0627\u062A \u0642\u0631\u0622\u0646\u064A\u0629 \u062C\u0645\u064A\u0644\u0629 \u0645\u0646 \u0642\u0631\u0627\u0626\u0643 \u0627\u0644\u0645\u0641\u0636\u0644\u064A\u0646 \u0645\u0639 \u0625\u0645\u0643\u0627\u0646\u064A\u0629 \u0627\u0644\u0648\u0635\u0648\u0644 \u0625\u0644\u0649 \u0623\u0643\u062B\u0631 \u0645\u0646 250 \u0642\u0627\u0631\u0626\u064B\u0627 \u0645\u0648\u062B\u0648\u0642\u064B\u0627 \u0628\u0647 \u0648\u062A\u0644\u0627\u0648\u0627\u062A \u0645\u062A\u0639\u062F\u062F\u0629 \u0645\u0646 \u062C\u0645\u064A\u0639 \u0623\u0646\u062D\u0627\u0621 \u0627\u0644\u0639\u0627\u0644\u0645 \u0627\u0644\u0625\u0633\u0644\u0627\u0645\u064A.",
        ctaButton: "\u0625\u0628\u062F\u0623 \u0641\u064A \u0627\u0644\u0625\u0633\u062A\u0645\u0627\u0639",
        // Recitaion
        selectReciter: "\u0625\u062E\u062A\u0631 \u0642\u0627\u0631\u0626",
        selectNarration: "\u0625\u062E\u062A\u0631 \u0627\u0644\u0645\u0635\u062D\u0641",
        selectSurah: "\u0625\u062E\u062A\u0631 \u0627\u0644\u0633\u0648\u0631\u0629",
        // Contact
        contactHeading: "\u0633\u0627\u0647\u0645 \u0645\u0639\u0646\u0627",
        contactDesc: "\u0633\u0627\u0647\u0645 \u0641\u064A \u062A\u062D\u0633\u064A\u0646 \u0647\u0630\u0627 \u0627\u0644\u0645\u0634\u0631\u0648\u0639 \u0645\u0646 \u062E\u0644\u0627\u0644 \u0627\u0644\u0645\u0633\u0627\u0639\u062F\u0629 \u0641\u064A \u0628\u0631\u0645\u062C\u0629 \u0627\u0644\u0645\u0648\u0642\u0639 \u0623\u0648 \u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0627\u0644\u0645\u0634\u0627\u0643\u0644",
        // contribute links
        fundTitle: "\u062A\u0645\u0648\u064A\u0644 \u0627\u0644\u0645\u0634\u0631\u0648\u0639",
        fundDesc: "\u063A\u064A\u0631 \u0645\u062A\u0627\u062D \u062D\u0627\u0644\u064A\u0627\u064B!",
        contributeTitle: "\u0639\u0631\u0636 \u0627\u0644\u0645\u0633\u062A\u0648\u062F\u0639",
        contributeDesc: "\u0627\u0628\u062F\u0623 \u0645\u0634\u0631\u0648\u0639\u0646\u0627",
        issueTitle: "\u0627\u0644\u0625\u0628\u0644\u0627\u063A \u0639\u0646 \u0627\u0644\u0645\u0634\u0627\u0643\u0644",
        issueDesc: "\u0633\u0627\u0639\u062F\u0646\u0627 \u0641\u064A \u0627\u0644\u0639\u062B\u0648\u0631 \u0639\u0644\u0649 \u0627\u0644\u0623\u062E\u0637\u0627\u0621 \u0648\u0625\u0635\u0644\u0627\u062D\u0647\u0627",
        pullReqTitle: "\u0625\u0631\u0633\u0627\u0644 \u0637\u0644\u0628 \u0633\u062D\u0628",
        pullReqDesc: "\u0633\u0627\u0647\u0645 \u0639\u0628\u0631 \u0627\u0644\u0643\u0648\u062F",
        // tool tip
        toolTipTitle: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0646\u0645\u0648\u0630\u062C",
        // conatct form
        formTitle: "\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0646\u0627",
        formNameHolder: "\u0627\u0644\u0627\u0633\u0645 \u0627\u0644\u0643\u0627\u0645\u0644 *",
        formEmailHolder: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A *",
        formMsgHolder: "\u0631\u0633\u0627\u0644\u062A\u0643 *",
        formSubmit: "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629",
        // Pop Up
        successTitle: "\u062A\u0645 \u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629!",
        successMsg: "\u0634\u0643\u0631\u064B\u0627 \u0639\u0644\u0649 \u0631\u0633\u0627\u0644\u062A\u0643. \u0633\u0646\u0639\u0627\u0648\u062F \u0627\u0644\u062A\u0648\u0627\u0635\u0644 \u0645\u0639\u0643 \u0642\u0631\u064A\u0628\u064B\u0627.",
        popClose: "\u0625\u063A\u0644\u0627\u0642",
        errorTitle: "\u062E\u0637\u0623",
        errorMsg: "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u0627\u064B.",
        // Fotter
        footerNav: "\u0627\u0644\u062A\u0646\u0642\u0644 \u0641\u064A \u0627\u0644\u0645\u0648\u0642\u0639",
        footerLinks: "\u0627\u0644\u0631\u0648\u0627\u0628\u0637",
        footerAPI: " \u0631\u0635\u064A\u062F \u0627\u0644\u0648\u0627\u062C\u0647\u0629 \u0627\u0644\u0628\u0631\u0645\u062C\u064A\u0629 (API)",
        footerWebSites: "\u0645\u0648\u0627\u0642\u0639 \u0645\u0634\u0627\u0628\u0647\u0629 \u0644\u0646\u0627",
        footerNewsletter: "\u0625\u0628\u0642 \u0639\u0644\u0649 \u0625\u0637\u0644\u0627\u0639",
        footerEmailPlaceholder: "\u0627\u0644\u0628\u0631\u064A\u062F \u0627\u0644\u0625\u0644\u0643\u062A\u0631\u0648\u0646\u064A \u0627\u0644\u062E\u0627\u0635 \u0628\u0643",
        footerSubscribe: "\u0625\u0634\u062A\u0631\u0643",
        footerPrivacy: "\u0627\u0644\u062E\u0635\u0648\u0635\u064A\u0629",
        footerTerms: "\u0627\u0644\u0634\u0631\u0648\u0637 \u0648\u0627\u0644\u0623\u062D\u0643\u0627\u0645",
        footerLicense: "\u0627\u0644\u0631\u062E\u0635\u0629"
    }
};
// Translate all elements with data-i18n attribute
function $fc9aec6a28d8da4a$var$translatePage(lang) {
    // Validate language
    if (!$fc9aec6a28d8da4a$var$translations[lang]) return;
    // Get all elements with data-i18n attribute
    const elements = document.querySelectorAll("[data-i18n]");
    elements.forEach((element)=>{
        const key = element.getAttribute("data-i18n");
        if ($fc9aec6a28d8da4a$var$translations[lang][key]) {
            // Check if element has data-i18n-attr for translating attributes
            const attr = element.getAttribute("data-i18n-attr");
            if (attr) // Translate attribute (like placeholder, title, etc.)
            element.setAttribute(attr, $fc9aec6a28d8da4a$var$translations[lang][key]);
            else // Translate text content
            element.textContent = $fc9aec6a28d8da4a$var$translations[lang][key];
        } else console.warn(`Translation key '${key}' not found for language '${lang}'`);
    });
}
// Translate input placeholders
function $fc9aec6a28d8da4a$var$translatePlaceholders(lang) {
    const elements = document.querySelectorAll("[data-i18n-placeholder]");
    elements.forEach((element)=>{
        const key = element.getAttribute("data-i18n-placeholder");
        if ($fc9aec6a28d8da4a$var$translations[lang][key]) element.setAttribute("placeholder", $fc9aec6a28d8da4a$var$translations[lang][key]);
    });
}
// Get translation by key
function $fc9aec6a28d8da4a$var$t(key, lang = null) {
    const currentLang = lang || localStorage.getItem("language") || "en";
    return $fc9aec6a28d8da4a$var$translations[currentLang][key] || key;
}
// Initialize translations on page load
document.addEventListener("DOMContentLoaded", ()=>{
    const currentLang = localStorage.getItem("language") || "en";
    $fc9aec6a28d8da4a$var$translatePage(currentLang);
    $fc9aec6a28d8da4a$var$translatePlaceholders(currentLang);
});
// Listen for language changes
window.addEventListener("languageChanged", (event)=>{
    $fc9aec6a28d8da4a$var$translatePage(event.detail.lang);
    $fc9aec6a28d8da4a$var$translatePlaceholders(event.detail.lang);
});
// Export for use in other scripts
if ($fc9aec6a28d8da4a$exports) $fc9aec6a28d8da4a$exports = {
    translatePage: $fc9aec6a28d8da4a$var$translatePage,
    t: $fc9aec6a28d8da4a$var$t
};


//# sourceMappingURL=repo.f78b278a.js.map
